































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { area, stations, getCityCode } from '@/api/api';
import { Notify, Dialog } from 'vant';
import wx from 'weixin-js-sdk';
import loading from '@/components/loading/loading.vue';

@Component({
	name: 'home',
	components: {
		loading
	}
})

export default class Home extends Vue {
	private areaName : string = '';
	private areaCode : string = '';
	private showPicker : boolean = false;
	private index : number = -1;
	private areas : any[] = [];
	private start : string = '';
	private end : string = '';
	private startShow : boolean = false;
	private endShow : boolean = false;
	private startPlace : string = '';
	private endPlace : string = '';
	private startStations : any[] = [];
	private endStations : any[] = [];
	private loading : boolean = true;

	// mounted
	private mounted() {
		area().then((res : any) => {
			const data : any[] = res.data;
			let areaCode : any = localStorage.getItem('areaCode');
			let index : number = 0;
			let areaName : string = data[0].areaName;
			if (areaCode) {
				data.forEach((item : any, i : number) => {
					if (areaCode === item.areaNewCode) {
						index = i;
						areaName = item.areaName;
					}
				});
			} else {
				areaCode = data[0].areaNewCode;
			}
			this.areaCode = areaCode;
			this.areaName = areaName;
			this.index = index;
			this.areas = data;
			// console.log(data);
			// this.getLoc();
			// this.getAllStations();
			this.loading = false;
			const firstEnter = sessionStorage.getItem('firstEnter');
			if (!firstEnter) {
				this.getLoc();
				sessionStorage.setItem('firstEnter', '1');
			}
		});
	}

	// methods
	// 切换城市
	private confirm(val : any, index : number) : void {
		this.index = index;
		this.areaName = val.areaName;
		this.areaCode = val.areaNewCode;
		localStorage.setItem('areaName', val.areaName);
		localStorage.setItem('areaCode', val.areaNewCode);
		this.showPicker = false;
	}
	// 获取所有站点
	private getStations(type : string, val : string) : void {
		const areaCode = this.areaCode;
		const siteName = val;
		stations({ areaCode, siteName }).then((res : any) => {
			// console.log(res);
			const data : any[] = res.data;
			if (type === 'start') {
				this.startStations = data;
			} else {
				this.endStations = data;
			}
		});
	}
	// 输入框获得焦点时间
	private focus(type : string) : void {
		if (type === 'start') {
			this.startShow = true;
			this.endShow = false;
		} else {
			this.startShow = false;
			this.endShow = true;
		}
	}
	// 输入框失去焦点事件
	private blur() : void {
		setTimeout(() => {
			this.startShow = false;
			this.endShow = false;
			this.start = this.startPlace;
			this.end = this.endPlace;
		}, 100);
	}
	// 输入框输入内容
	@Watch('start', { deep: true })
	private onStartChanged(val : string, oldVal : string) {
		if (val) {
			this.getStations('start', val);
		} else {
			this.startStations = [];
		}
	}
	@Watch('end', { deep: true })
	private onEndChanged(val : string, oldVal : string) {
		if (val) {
			this.getStations('end', val);
		} else {
			this.endStations = [];
		}
	}
	// 选择站点
	private chooseStation(type : string, name : string) : void {
		if (type === 'start') {
			this.startPlace = name;
			this.start = name;
		} else {
			this.endPlace = name;
			this.end = name;
			this.startShow = false;
			this.endShow = false;
		}
	}
	// 查询
	private query() : void {
		const begin : string = this.startPlace;
		const end : string = this.endPlace;
		if (!begin) {
			Notify('请输入出发地');
			return;
		}
		if (!end) {
			Notify('请输入目的地');
			return;
		}
		this.$router.push({
			path: '/query',
			query: {
				begin,
				end
			}
		});
	}
	// 获取当前位置
	private getLoc() : void {
		const _this = this;
		wx.ready(() => {
			wx.getLocation({
				type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
				success: (res : any) => {
					// console.log(res);
					const longitude = res.longitude;
					const latitude = res.latitude;
					getCityCode({ longitude, latitude }).then((res : any) => {
						const cityCode : any = res.data.regeocode.addressComponent.adcode;
						const areas = _this.areas;
						let flag : boolean = false;
						let cityName : string = '';
						const areaCode : any = localStorage.getItem('areaCode');
						if (areaCode !== cityCode) {
							areas.forEach((area : any) => {
								if (area.areaNewCode === cityCode) {
									cityName = area.areaName;
									flag = true;
									return false;
								}
							});
							if (flag) {
								Dialog.confirm({
									title: '提示',
									message: `当前定位在${cityName}，是否切换到${cityName}？`
								}).then(() => {
									_this.showPicker = true;
								}).catch(() => {
									// on cancel
								});
							} else {
								Dialog.confirm({
									title: '提示',
									message: '当前定位位置没有开通服务，是否选择地区？'
								}).then(() => {
									_this.showPicker = true;
								}).catch(() => {
									// on cancel
								});
							}
						}

					});

				},
				cancel: () => {
					Dialog.confirm({
						title: '提示',
						message: '定位失败，是否选择地区？'
					}).then(() => {
						_this.showPicker = true;
						localStorage.setItem('fistEnter', '1');
					}).catch(() => {
						// on cancel
						localStorage.setItem('fistEnter', '1');
					});
				}
			});
		});
	}
}
